import React from 'react';

function Process() {
  return (
    <section className="tc-process-style2">
      <div className="container">
        <h2 className="fsz-45 fw-500 mb-80 text-center">
          Our Approach
          <span className="sub-font fst-italic color-orange1 fw-400">
            process
          </span>
        </h2>
        <div className="content">
          <div className="row">
            <div className="col-lg-5">
              <div className="accordion-side wow fadeInUp slow">
                <div className="accordion" id="accordionProcess">

  {/* 1 */}
  <div className="accordion-item">
    <div className="accordion-header" id="headingOne">
      <button
        className="accordion-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
      >
        <span className="num"> 1 / </span>
        <h3> Site Assessment & Consultation </h3>
      </button>
    </div>
    <div
      id="collapseOne"
      className="accordion-collapse collapse show"
      data-bs-parent="#accordionProcess"
    >
      <div className="accordion-body">
        <div className="text">
          We begin with a detailed site visit, measurements, and discussions
          to understand your vision, requirements, budget, and project goals.
        </div>
      </div>
    </div>
  </div>

  {/* 2 */}
  <div className="accordion-item">
    <div className="accordion-header" id="headingTwo">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
      >
        <span className="num"> 2 / </span>
        <h3> Concept Design & Presentation </h3>
      </button>
    </div>
    <div
      id="collapseTwo"
      className="accordion-collapse collapse"
      data-bs-parent="#accordionProcess"
    >
      <div className="accordion-body">
        <div className="text">
          Our team develops space plans, design concepts, and mood boards,
          presenting ideas through detailed presentations for your review and
          approval.
        </div>
      </div>
    </div>
  </div>

  {/* 3 */}
  <div className="accordion-item">
    <div className="accordion-header" id="headingThree">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseThree"
      >
        <span
          className="num"
          style={{ whiteSpace: "nowrap", display: "inline-block" }}
        >
          3 /
        </span>
        <h3 style={{ display: "inline-block", margin: 0 }}>
          3D Visualization & Material Selection
        </h3>
      </button>
    </div>
    <div
      id="collapseThree"
      className="accordion-collapse collapse"
      data-bs-parent="#accordionProcess"
    >
      <div className="accordion-body">
        <div className="text">
          Realistic 3D views help you visualize the final outcome while we
          assist in selecting materials, finishes, lighting, and furnishings
          that align with your design vision.
        </div>
      </div>
    </div>
  </div>

  {/* 4 */}
  <div className="accordion-item">
    <div className="accordion-header" id="headingFour">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFour"
      >
        <span className="num"> 4 / </span>
        <h3> Detailed Planning & Execution </h3>
      </button>
    </div>
    <div
      id="collapseFour"
      className="accordion-collapse collapse"
      data-bs-parent="#accordionProcess"
    >
      <div className="accordion-body">
        <div className="text">
          We prepare comprehensive drawings, specifications, and project
          documentation, followed by seamless execution with continuous site
          supervision and quality control.
        </div>
      </div>
    </div>
  </div>

  {/* 5 */}
  <div className="accordion-item">
    <div className="accordion-header" id="headingFive">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFive"
      >
        <span className="num"> 5 / </span>
        <h3> Handover & Support </h3>
      </button>
    </div>
    <div
      id="collapseFive"
      className="accordion-collapse collapse"
      data-bs-parent="#accordionProcess"
    >
      <div className="accordion-body">
        <div className="text">
          After final inspections and quality checks, we deliver a completed
          space and remain available for post-completion support.
        </div>
      </div>
    </div>
  </div>

</div>
                <a
                  href="contact"
                  className="butn bg-white rounded-pill mt-50 hover-bg-black"
                >
                  <span>
                    Contact Us
                    <i className="ms-2 fal fa-long-arrow-right ico-45"></i>
                  </span>
                </a>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="imgs">
                <div className="img" data-lag="0.2">
                  <img
                    src="/innerpages/assets/img/process/proc4.jpg"
                    alt=""
                    className="img-cover"
                  />
                  <span className="txt sub-font"> Measure </span>
                </div>
                <div className="img" data-lag="0.4">
                  <img
                    src="/innerpages/assets/img/process/proc2.jpg"
                    alt=""
                    className="img-cover"
                  />
                  <span className="txt sub-font"> Design </span>
                </div>
                <div className="img" data-lag="0.3">
                  <img
                    src="/innerpages/assets/img/process/proc3.jpg"
                    alt=""
                    className="img-cover"
                  />
                  <span className="txt sub-font"> Visualize </span>
                </div>
                {/* 4 - now Deliver */}
<div className="img" data-lag="0.5">
  <img
    src="/innerpages/assets/img/process/proc5.jpg"
    alt=""
    className="img-cover"
  />
  <span className="txt sub-font"> Execute </span>
</div>

{/* 5 - now Execute */}
<div className="img" data-lag="0.6">
  <img
    src="/innerpages/assets/img/process/proc1.jpg"
    alt=""
    className="img-cover"
  />
  <span className="txt sub-font"> Deliver </span>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        src="/innerpages/assets/img/prc_bg.png"
        alt=""
        className="bg"
        data-speed="1.2"
      />
    </section>
  );
}

export default Process;
